import { PageHeader } from "../components/PageHeader";

const principles = [
  ["Simple", "No accounts, no fees, no surprise charges."],
  ["Private by default", "Your job details stay on your device until you choose to send them."],
  ["Honest about limits", "We do not vet contractors. Always check licenses and references."],
];

export function AboutPage() {
  return (
    <article className="mx-auto max-w-[56ch] space-y-10">
      <PageHeader eyebrow="About" title="Built for small jobs the big platforms ignore.">
        ClearScope helps homeowners and local pros agree on what needs done without paying anyone
        for the introduction.
      </PageHeader>
      <div className="space-y-5 text-base leading-8 text-text-muted">
        <p>
          Use it to turn quick notes into a clear job brief, then send that brief to any contractor
          by email or text. The other person does not need an account.
        </p>
        <p>
          The app is free to use. We do not sell leads, take payments, rank pros, or push you into
          one hiring path.
        </p>
      </div>
      <section className="divide-y divide-border border-y border-border">
        {principles.map(([title, body], index) => (
          <div key={title} className="grid gap-3 py-5 md:grid-cols-[3rem_10rem_1fr] md:items-start">
            <p className="font-mono text-xs font-semibold tracking-normal text-text-subtle num">
              {String(index + 1).padStart(2, "0")}
            </p>
            <h2 className="font-sans text-xl font-semibold text-text-strong">{title}</h2>
            <p className="text-sm leading-6 text-text-muted">{body}</p>
          </div>
        ))}
      </section>
      <blockquote className="border-l-2 border-l-accent-500 pl-6 text-lg italic leading-7 text-text-muted">
        Clear job, clear quote, clear work done.
      </blockquote>
    </article>
  );
}
